import {
    Color,
    Group,
    LinearFilter,
    LinearMipMapLinearFilter,
    Mesh,
    MeshPhongMaterial,
    MeshStandardMaterial,
    Texture,
    sRGBEncoding,
} from "three";

export const updateOtherMaterials = (object: Group) => {
    object.traverse((elem) => {
        if ((elem as Mesh).isMesh) {
            const mesh = elem as Mesh;
            mesh.receiveShadow = true;
            mesh.castShadow = true;

            if (Array.isArray(mesh.material)) {
                for (let mat of mesh.material) {
                    if (mat.type === "MeshPhongMaterial") {
                        const material = mat as MeshPhongMaterial;
                        material.emissive = material.color;
                        material.emissiveIntensity = 2;
                        material.aoMapIntensity = 0.9;
                        material.shininess = 10;

                        material.flatShading = true;
                        material.needsUpdate = true;
                    }
                }
            } else {
                if (mesh.material.type === "MeshStandardMaterial") {
                    const material = mesh.material as MeshStandardMaterial;
                    if (material.name === "metall") {
                        material.metalness = 1;
                        material.roughness = 0.3;
                    } else if (material.name === "steklo") {
                        material.metalness = 1;
                    } else if (material.name === "plastic") {
                        material.metalness = 0;
                        material.roughness = 0.2;
                    } else {
                        material.metalness = 0;
                        material.roughness = 0.5;
                    }
                    if (!material.map) {
                        material.emissive = material.color;
                        material.emissiveIntensity = 0.3;
                    }
                }
            }
        }
    });

    object.userData.isMapLoaded = true;
};
